var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactSheetCompare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 16.6667,
    fill: "#333333",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1 12.8H14.8C14.3226 12.8 13.8648 12.9896 13.5272 13.3272C13.1896 13.6648 13 14.1226 13 14.6V25.4C13 25.8774 13.1896 26.3352 13.5272 26.6728C13.8648 27.0104 14.3226 27.2 14.8 27.2H21.1M24.7 12.8H25.6C26.0774 12.8 26.5352 12.9896 26.8728 13.3272C27.2104 13.6648 27.4 14.1226 27.4 14.6V15.5M27.4 24.5V25.4C27.4 25.8774 27.2104 26.3352 26.8728 26.6728C26.5352 27.0104 26.0774 27.2 25.6 27.2H24.7M27.4 19.1V20.9M20.2 11V29",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactSheetCompare);
export default __webpack_public_path__ + "static/media/FactSheetCompare.3fc702f15beeb5e21c22c5743d23a1c0.svg";
export { ForwardRef as ReactComponent };